import React from 'react';
import PropTypes from 'prop-types';

import { EditIcon } from 'common/icons';
import { ActionsButton, Tooltip } from 'common/components';

import { staticStyles } from './style';

const LeverageCell = ({ loading, leverage, onLeverageChangeClick, isBlocked, displayLeverageAsUnlimited }) => (
  <div className="LeverageCell">
    {!loading ? (
      <div>
        {leverage ? (
          <div className="LeverageCell__inner">
            <p>
              1:
              {displayLeverageAsUnlimited ? 'unlimited' : leverage}
            </p>

            <Tooltip id="clientChangeLeverageTooltip" textId={isBlocked ? 'clientChangeLeverageBlockedAccount' : ''}>
              <ActionsButton edit onClickFunc={onLeverageChangeClick} disabled={isBlocked}>
                <EditIcon />
              </ActionsButton>
            </Tooltip>
          </div>
        ) : (
          <div className="LeverageCell__inner">—</div>
        )}
      </div>
    ) : (
      '...'
    )}
    <style jsx>{staticStyles}</style>
  </div>
);

LeverageCell.propTypes = {
  loading: PropTypes.bool.isRequired,
  leverage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onLeverageChangeClick: PropTypes.func.isRequired,
  isBlocked: PropTypes.bool,
  displayLeverageAsUnlimited: PropTypes.bool,
};

LeverageCell.defaultProps = {
  leverage: null,
  isBlocked: false,
  displayLeverageAsUnlimited: false,
};

export default LeverageCell;
